module.exports = __webpack_public_path__ + "static/media/IMG_8919.3bbe5824.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/vertical/IMG_8919.jpg
// module id = 115
// module chunks = 0